const url = '/classes';
const Provider = 'Classes';
const dbModel = 'Classes';

export { url, Provider, dbModel };
